import { render, staticRenderFns } from "./RallyRegisterAddress.vue?vue&type=template&id=b50c3efe&"
import script from "./RallyRegisterAddress.vue?vue&type=script&lang=ts&"
export * from "./RallyRegisterAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports